import React, { useEffect, useState } from 'react';
import DataTable from '../../components_shared/DataTable';
import { financeAPI } from '../../utils/api';
import Swal from 'sweetalert2';

export default function BillsPage() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const res = await financeAPI.bills.getAll();
      setRows(res.data.content || res.data);
    } catch (e) {
      Swal.fire({ icon: 'error', title: 'Error', text: e.message });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  const act = async (fn, id, confirmText) => {
    const ok = await Swal.fire({ icon:'question', text: confirmText, showCancelButton:true });
    if(!ok.isConfirmed) return;
    try{
      await fn(id);
      await load();
      Swal.fire({ icon:'success', text:'Updated' });
    }catch(e){ Swal.fire({ icon:'error', text:e.message }); }
  };

  const columns = [
    { header: 'Bill #', accessorKey: 'id' },
    { header: 'Invoice', accessorKey: 'invoiceRef' },
    { header: 'Status', accessorKey: 'status' },
    { header: 'Created', accessorKey: 'createdAt' },
    {
      header: 'Actions',
      cell: info => {
        const b = info.row.original;
        const btn = (label, onClick) => (
          <button style={{ marginRight: 6 }} onClick={onClick}>{label}</button>
        );
        switch(b.status){
          case 'CREATED':
            return btn('Receive',()=>act(financeAPI.receiveBill,b.id,'Mark bill as received?'));
          case 'RECEIVED':
            return btn('Process',()=>act(financeAPI.processBill,b.id,'Process bill?'));
          case 'PROCESSED':
            return btn('Approve',()=>act(financeAPI.approveBill,b.id,'Approve bill?'));
          default:
            return '-';
        }
      }
    }
  ];

  return (
    <div>
      <h3 style={{ marginBottom:12 }}>Bills</h3>
      {loading ? <div>Loading...</div> : <DataTable data={rows} columns={columns} />}
    </div>
  );
}
